import { createAsyncThunk } from "@reduxjs/toolkit";
import useAxios from "../../utils/useAxios";
import { URL_SUMMARY_REPORT } from "config/connString";

const exportTestOrders = createAsyncThunk(
  "summary-report/export-test-orders",
  async (params) => {
    try {
      const api = useAxios();
      const config = {
        params: {
          clientId: params?.clientId,
          startOrderDate: params?.startOrderDate,
          endOrderDate: params?.endOrderDate,
          sortField: params?.sortField,
          sortDirection: params?.sortDirection,
        },
        responseType: "blob",
      };

      const newUrlPath = `/test-orders-export?${params?.statuses
        ?.map((status) => `statuses=${status}`)
        .join("&")}`;

      const response = await api.get(URL_SUMMARY_REPORT + newUrlPath, config);

      return {
        blob: new Blob([response?.data], { type: response?.data?.type }),
      };
    } catch (error) {
      return Promise.reject(error.response);
    }
  }
);

export { exportTestOrders };
